<ng-container thr-parent-form>
    <div class="row">
        <div class="col-12">
            <mat-form-field class="full-width mb-3 mb-sm-4">
                <mat-select
                    [name]="prefix + 'Relationship'"
                    [placeholder]="'form.relationship' | translate"
                    required
                    [disabled]="isDisabled"
                    [(ngModel)]="relationship.code"
                    #relationshipCtrl="ngModel"
                >
                    <mat-option [value]="RelativeRelationshipCode.SPOUSE">
                        {{ 'form.relationship-code.CY' | translate }}
                    </mat-option>
                    <mat-option [value]="RelativeRelationshipCode.SON">
                        {{ 'form.relationship-code.HJ' | translate }}
                    </mat-option>
                    <mat-option [value]="RelativeRelationshipCode.FATHER">
                        {{ 'form.relationship-code.PD' | translate }}
                    </mat-option>
                    <mat-option [value]="RelativeRelationshipCode.BROTHER">
                        {{ 'form.relationship-code.HR' | translate }}
                    </mat-option>
                    <mat-option [value]="RelativeRelationshipCode.RELATED">
                        {{ 'form.relationship-code.AL' | translate }}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="relationshipCtrl.hasError('required')">
                    {{ 'form.validation.required' | translate }}
                </mat-error>
                <mat-hint>
                    {{ 'full-data.alleged-help' | translate }}
                </mat-hint>
            </mat-form-field>
        </div>
        <div class="col-12 col-sm-6">
            <mat-form-field class="full-width mb-3 mb-sm-4">
                <input
                    [name]="prefix + 'Name'"
                    matInput
                    [placeholder]="'form.name' | translate"
                    required
                    maxlength="20"
                    [(ngModel)]="relationship.name"
                    #nameCtrl="ngModel"
                />
                <mat-error *ngIf="nameCtrl.hasError('required')">
                    {{ 'form.validation.required' | translate }}
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-12 col-sm-6">
            <mat-form-field class="full-width mb-3 mb-sm-4">
                <input
                    [name]="prefix + 'Surname'"
                    matInput
                    [placeholder]="'form.surname' | translate"
                    required
                    maxlength="60"
                    [(ngModel)]="relationship.surname"
                    #surnameCtrl="ngModel"
                />
                <mat-error *ngIf="surnameCtrl.hasError('required')">
                    {{ 'form.validation.required' | translate }}
                </mat-error>
            </mat-form-field>
        </div>
    </div>
</ng-container>
